import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import moment from 'moment';

Component('tr-time-log-time-field', {
  mixins: [eventListenerMixin],

  ready() {
    this.startAtField = this.querySelector('.starts-at');
    this.endAtField = this.querySelector('.ends-at');
    this.duration = this.querySelector('.duration');
    this.addEventListeners();
    this.updateDuration();
  },

  addEventListeners() {
    this.listenTo(this.startAtField, 'tr-date-time-field:change', this.handleDateTimeChange.bind(this));
    this.listenTo(this.endAtField, 'tr-date-time-field:change', this.handleDateTimeChange.bind(this));
  },

  handleDateTimeChange() {
    this.updateDuration();
  },

  updateDuration() {
    const startAt = this.startAtField.value();
    const endAt = this.endAtField.value();
    if (startAt.length === 0 || endAt.length === 0) {
      this.duration.querySelector('.minutes').textContent = 0;
      return;
    }
    const startsAtMoment = moment(startAt);
    const endsAtMoment = moment(endAt);
    const duration = moment.duration(endsAtMoment.diff(startsAtMoment));
    this.duration.querySelector('.minutes').textContent = duration.as('minutes');
  },

  disconnected() {
    this.stopListening();
  },
});
